// app/javascript/channels/notification_channel.js

import consumer from './consumer';

// The notifications menus (controllers/notifications_controller.js) share one subscription: the first menu to connect
// opens it and the last to leave closes it. Pages without the bell (signed out, the patient portal, signing,
// teletherapy guests) never subscribe, and ActionCable opens no socket until something does.
let subscription = null;
let subscribers = 0;

// eslint-disable-next-line import/prefer-default-export
export function subscribeToNotifications() {
  subscribers += 1;
  subscription ||= consumer.subscriptions.create('Noticed::NotificationChannel', {
    received(data) {
      window.dispatchEvent(
        new CustomEvent('notifications-unread-count', { detail: { unreadCount: Number(data.unread_count) || 0 } })
      );
    },
  });

  let subscribed = true;
  return () => {
    if (!subscribed) return;
    subscribed = false;
    subscribers -= 1;
    if (subscribers > 0) return;

    subscription.unsubscribe();
    subscription = null;
  };
}
